import script from "./Pivot.vue?vue&type=script&setup=true&lang=js"
export * from "./Pivot.vue?vue&type=script&setup=true&lang=js"

import "./Pivot.vue?vue&type=style&index=0&id=1b2c8fcf&lang=scss"

const __exports__ = script;

export default __exports__